















































































































































































import { Component, Vue } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
import SingleImageUpload from '@/component/single-image-upload.vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
const getUrl = require('baimahu/url-with-param');
const UPLOAD_DIR = {
  list_image: 'list_image',
  detail: 'detail',
};
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  add: `${FCAPI}/shang/ruan/sample`,
  get_list: `${FCAPI}/shang/ruan/community/name`,
  get_detail: `${FCAPI}/shang/ruan/sample/`,
  edit_community: `${FCAPI}/shang/ruan/sample`,
};

const MAX_LENGTH = 20;

const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/forEach'),
  map: require('lodash/map'),
};

// 必填项
interface Validator {
  field: string;
  validate: (value: any, avtivity: any) => boolean;
  message: string;
  status: 'success' | 'error';
  help: string;
}

// 必填项提示信息列表
function getValidatorMap(): { [field: string]: Validator } {
  const list: any[] = [
    {
      field: 'name',
      validate: (value: string): boolean => !!value,
      message: '请输入名称',
    },
    {
      field: 'community_id',
      validate: (value: string): boolean => !!value,
      message: '请选择小区',
    },
    {
      field: 'list_img_url',
      validate: (value: string): boolean => !!value,
      message: '请选择列表图',
    },
    {
      field: 'detail_type',
      validate: (value: string): boolean => !!value,
      message: '',
    },
  ].map((item): Validator => ({ ...item, status: 'success', help: '' }));
  return _.keyBy(list, (item: Validator) => item.field);
}

function initForm(remote?: any) {
  remote = remote || {};
  return {
    name: remote.name || '',
    detail_img_url: remote.detail_img_url || [],
    list_img_url: remote.list_img_url || '',
    community_id: remote.community_id || undefined,
    detail_url: remote.detail_url || '',
    detail: remote.detail || 1,
    description: remote.description || '',
  };
}
@Component({
  components: {
    SingleImageUpload,
    MultipleImageUpload,
  },
})
export default class AddTemplateRoom extends Vue {
  is_loading: boolean = false;
  form_item_layout: any = {
    labelCol: { span: 2 },
    wrapperCol: { span: 22 },
  };
  validatorMap: { [field: string]: Validator } = getValidatorMap();
  community_data: any = [];
  form: any = initForm();
  modal_image_src: string = '';
  is_edit: boolean = false;
  is_show_image_modal: boolean = false;
  get uploadDir() {
    return UPLOAD_DIR;
  }

  get maxLength() {
    return MAX_LENGTH;
  }

  listBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  // 判断是否有必选项没有填
  validateCommit() {
    const form = this.form as any;
    let is_valid: boolean = true;
    _.each(this.validatorMap, (validator: Validator, field: string) => {
      if (!this.validate(field)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
    }
    return is_valid;
  }

  validate(field: string) {
    const form = this.form as any;
    let is_valid = this.validatorMap[field].validate(form[field], form);
    this.validatorMap[field].status = is_valid ? 'success' : 'error';
    this.validatorMap[field].help = is_valid ? '' : this.validatorMap[field].message;
    if (field === 'detail_type') {
      if (this.form.detail === 1) {
        if (!this.form.detail_url) {
          this.validatorMap[field].status = 'error';
          this.validatorMap[field].help = '请输入链接';
          is_valid = false;
        } else {
          this.validatorMap[field].status = 'success';
          this.validatorMap[field].help = '';
          is_valid = true;
        }
      }
      if (this.form.detail === 0) {
        if (this.form.detail_img_url.length <= 0) {
          this.validatorMap[field].status = 'error';
          this.validatorMap[field].help = '请上传详情图';
          is_valid = false;
        } else {
          this.validatorMap[field].status = 'success';
          this.validatorMap[field].help = '';
          is_valid = true;
        }
      }
    }
    return is_valid;
  }

  handlePreview(imageUrl: string) {
    this.modal_image_src = imageUrl;
    this.is_show_image_modal = true;
  }

  detailBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  // 获取小区列表
  @changeLoading(['is_loading'])
  async getCommunityList() {
    const res = await this.$axios.get(API.get_list);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.community_data = res.data.data;
  }

  // 获取小区详情
  @changeLoading(['is_loading'])
  async getCommuntiyDetail() {
    const res = await this.$axios.get(`${API.get_detail}${this.$route.query.id}/edit`);
    if (res.data.status !== 200) {
      this.$message.error((res as any).message);
      return;
    }
    this.form = initForm(res.data.data);
    this.form.detail = res.data.data.detail_type;
    this.form.detail_img_url = res.data.data.detail_type === 0 ? res.data.data.detail_img_url.split(',') : [];
  }

  // 点击提交按钮
  @changeLoading(['is_loading'])
  async submit() {
    if (!this.validateCommit()) {
      return;
    }
    const data = this.form;
    let res;
    const sendData = {
      name: data.name,
      community_id: data.community_id,
      detail_img_url: data.detail === 0 ? data.detail_img_url.join(',') : '',
      list_img_url: data.list_img_url,
      detail_type: data.detail,
      detail_url: data.detail === 1 ? data.detail_url : '',
      description: data.detail === 1 ? '' : data.description,
    };
    if (this.is_edit) {
      res = await this.$axios.put(`${API.edit_community}/${this.$route.query.id}`, sendData);
    } else {
      res = await this.$axios.post(API.add, sendData);
    }
    if (res.data.status !== 200) {
      this.$message.error((res as any).message);
      return;
    }
    this.$router.go(-1);
    this.$message.success(this.is_edit ? '编辑成功' : '新增成功');
  }

  @changeLoading(['is_loading'])
  async created() {
    if (this.$route.query.id) {
      this.is_edit = true;
      await this.getCommuntiyDetail();
    }
    await this.getCommunityList();
  }
}
